import React from 'react';
import axios from 'axios'
import { Link } from 'react-router-dom'
import './page.module.css'

class Categories extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            search: '',
            categoriesPage: [],
            gotoCategory: ""
        }
    }

    componentDidMount(){
        axios.get('https://www.themealdb.com/api/json/v1/1/categories.php')
        .then(res => 
            // console.log(res)
            this.setState({
                categoriesPage: res.data.categories
            })
        )
    }

    handleCategory = (category) => {
        this.setState({
            gotoCategory: category,
        })
        // return(console.log(category))
    }

    render(){
        return(
            <div className="row my-5">
                {
                    this.state.categoriesPage && this.state.categoriesPage.map(item => (
                        <div className="col-12 col-sm-6 col-xl-4" key={item.idCategory}>
                            <div className="col my-4">
                                <div className="card mx-auto shadow" style={{width: 25+"rem"}}>
                                    <img src={item.strCategoryThumb} className="card-img-top" alt="" />
                                    <div className="card-body" style={{backgroundColor: "#fb6621"}}>
                                        <Link id="categoryCard" to={`/categories/${item.strCategory}`}>{item.strCategory}</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        )
    }
}

export default Categories